<mat-drawer-container class="main-layout" [class.main-layout--compact]="compact">
  <mat-drawer
    class="navigation-drawer"
    [mode]="compact ? 'over' : 'side'"
    [opened]="drawerOpened"
    (openedChange)="onDrawerOpenedChange($event)">
    <app-menu [overlay]="compact" (menuClosed)="closeOverlay()"></app-menu>
  </mat-drawer>
  <mat-drawer-content class="content-pane">
    <header class="app-bar" *ngIf="compact">
      <button
        mat-icon-button
        type="button"
        class="app-bar__toggle"
        (click)="toggleMenu()"
        [attr.aria-expanded]="drawerOpened"
        [attr.aria-label]="(drawerOpened ? 'app.menu.links.closeMenu' : 'app.menu.links.openMenu') | translate">
        <mat-icon>{{ drawerOpened ? 'close' : 'menu' }}</mat-icon>
      </button>
      <div class="app-bar__brand">
        <span class="app-bar__title">JDR</span>
        <span class="app-bar__subtitle">Personnages</span>
      </div>
    </header>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>